<template>
  <v-snackbar
    :id="id"
    style="z-index: 999"
    v-model="snackbar"
    :timeout="timeout"
    :color="color"
    bottom
    center
    class="text-capitalize"
  >
    {{ text }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'message',
  data: () => ({
    id: null,
    snackbar: false,
    text: undefined,
    timeout: 4000,
    color: undefined
  }),
  methods: {
    show (color = 'success', msg) {
      this.color = color
      this.text = msg
      this.snackbar = true
    },
    showSuccess (msg) {
      this.id = 'success_notification'
      this.color = 'success'
      this.text = msg
      this.snackbar = true
    },
    showError (msg) {
      this.id = 'warning_notification'
      this.color = '#d4cc03'
      this.text = msg
      this.snackbar = true
    },
    activeMessage (response) {
      this.text = response.data ? response.data.message : 'Warning'
      if (response.status === 200) {
        this.showSuccess(this.text)
      } else {
        this.showError(this.text)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/message/message.vue